import React, {Component} from "react";
import {HistoryExtended, initPlayerColors, Skeleton, updatePlayerRatio} from "../../helpers/rendererHelper";
import AppConfig from "../../config/config.json";
import {
    formatConfig,
    getConfigAsync,
    getConfigUrl, getTimelineAsync,
} from "../../helpers/configHelper";
import "./SplitHistory.css";
import {getIframeWindowFromParent, isTrustedMessageOrigin} from "../../helpers/windowHelper";

export default class SplitHistory extends Component {
    ready = false;

    constructor(props) {
        super(props);

        this.state = {
            configUrl: getConfigUrl(props),
            configId: props.configId,
            templateName: props.templateName,
            stationIndex: 0,
            timeline: [],
            isSingleHistory: false,
            preview: props.preview,
        }
    }

    async componentDidMount() {
        if (this.state.templateName || this.state.configId) {
            getConfigAsync(this.state.configUrl).then((config) => {
                if (config) {
                    this.setState(formatConfig(config, this.state));
                    this.setHistoryReady();
                    this.fetchTimeline(config);
                } else {
                    window.location.href = `${AppConfig.basename}/404`;
                }
            });
        } else {
            this.addConfigListener();
        }
    }

    addConfigListener = () => {
        window.addEventListener('message', event => {
            // only accept messages from the player itself (parent window)
            if (!isTrustedMessageOrigin(event.origin)) {
                return;
            }

            let config;
            try {
                config = JSON.parse(event.data);
            } catch (e) {
                return;
            }

            // on new config coming from the main iframe, update the split history state
            this.setState({...this.state, ...config});
            initPlayerColors({...this.state, ...config});
            this.setHistoryReady();

            if (config.splitHistoryRatio) {
                updatePlayerRatio(1, config.splitHistoryRatio);
            }
        });
    }

    fetchTimeline = (config) => {
        const stationId = config.stations[0]?.id;

        if (stationId) {
            getTimelineAsync(stationId).then((timeline) => {
                // check if the station hasn't changed when receiving the new timeline
                if (stationId === this.state.stations[this.state.stationIndex]?.id) {
                    this.setState({timeline, timelineLoaded: true, isSingleHistory: true}, () => {
                        this.subscribeRPSForNewMetadata(config);
                    });
                }
            });
        }
    }

    subscribeRPSForNewMetadata = (config) => {
        const stationId = config.stations[0]?.id;
        if (window.IPS && stationId) {
            try {
                window.IPS.subscribe(
                    'radio', {'uid': 'metadata/' + stationId + '/new_metadata'},
                    (res, mixed) => {
                        if (res === true) {
                            mixed.on('radio', data => {
                                const string = String.fromCharCode.apply(String, data);
                                try {
                                    let lastMetadata = JSON.parse(JSON.parse(string));
                                    this.setState({timeline: [...this.state.timeline, lastMetadata]});
                                } catch (error) {
                                    console.log(error)
                                }
                            });
                        } else {
                            console.log("WS subscribe fail for last metadata");
                        }
                    }
                );
            } catch (err) {
                console.log("WS subscribe fail for last metadata");
            }
        }
    }

    setHistoryReady = () => {
        if (!this.ready) {
            this.ready = true;
            window.top.postMessage('player-ready', '*');
        }
    }

    handleSeekTo = (value) => {
        const mainPlayerRegex = this.state.uuid ? new RegExp(`\/(prod)\/.*\/${this.state.uuid}\$`) : /^\/2\/(template)\/.*\/(blank)$/;
        const mainPlayerWindow = getIframeWindowFromParent(mainPlayerRegex);

        if (mainPlayerWindow) {
            mainPlayerWindow.postMessage(JSON.stringify({
                seekTo: value,
            }));
        }
    }

    render() {
        const {
            backgroundColor,
            bufferSize,
            buttonColor,
            currentTrack,
            fragment,
            historyHold,
            isDirectControl,
            isHistoryTimeDisplay,
            isHistoryClickable,
            isHlsBuffered,
            isSingleHistory,
            playlist,
            playing,
            preview,
            previousPlayTime,
            secondaryColor,
            stream,
            timeline,
            timelineLoaded,
        }  = this.state;

        return <>
            <Skeleton hidden={this.ready}></Skeleton>

            {this.ready && <div className="player-split-history" style={{background: backgroundColor}}>
                <HistoryExtended timeline={timeline} timeColor={secondaryColor} isSingleHistory={isSingleHistory}
                                 textColor={buttonColor} isDirectControl={isDirectControl}
                                 currentTrack={currentTrack} streamFormat={stream?.format}
                                 backgroundColor={backgroundColor} historyHold={historyHold}
                                 fragment={fragment} playlist={playlist} isHlsBuffered={isHlsBuffered}
                                 currentTime={previousPlayTime} bufferSize={bufferSize}
                                 onClick={this.handleSeekTo} preview={preview} playing={playing}
                                 showTimecode={isHistoryTimeDisplay} timelineLoaded={timelineLoaded}
                                 allowTimeshift={isHistoryClickable} historyDisplay="split"
                />
            </div>}
        </>
    }
}
